import type { VIDEO_DATA, VIDEO_PARAMS } from './types'

import { DEFAULT_PADDING, DEFAULT_WIDTH, generateForAllDevice } from '../const'

export const DEFAULT_VIDEO_PARAMS = (): VIDEO_PARAMS =>
  generateForAllDevice({
    width: DEFAULT_WIDTH(),
    hidden: false,
    padding: DEFAULT_PADDING(),
  })

export const DEFAULT_VIDEO_DATA = (): VIDEO_DATA => ({
  type: 'video',
  autoPlay: false,
  loop: false,
  muted: false,
  startTime: null,
  endTime: null,
  url: null,
  data: { source: 'upload', document: null, pendingDocument: null, hash: null },
})

export const DEFAULT_VIDEO_ADDITIONAL_DOCUMENTS = (): string[] => ['data']